/* eslint-disable react-hooks/exhaustive-deps */
import { Input } from 'antd';
import React, { useEffect, useMemo } from 'react';

const Text = ({
  updateData = () => { },
  k = {},
  v = {},
  data = {},
  firstItem = {},
  showIf = true,
  areYouSureState = false,
  placeholder = '',
}) => {
  const isDisabled = useMemo(() => {
    if (v) {
      if (v.disabled) {
        return true;
      }

      const colConfig = v.columnConfig;
      if (colConfig) {
        if (colConfig.inheritFromFirstItem) {
          return true;
        }
      }
    }

    if (!showIf) {
      return true;
    }

    if (areYouSureState) {
      return true;
    }

    return false;
  }, [v, showIf, areYouSureState]);

  useEffect(() => {
    if (v) {
      const colConfig = v.columnConfig;
      if (colConfig) {
        if (colConfig.inheritFromFirstItem && firstItem && firstItem[k]) {
          updateData(k, firstItem[k]);
        }
      }
    }
  }, [v, k, firstItem]);

  return (
    <div key={k}>
      <Input
        placeholder={placeholder}
        value={data[k]}
        onChange={(e) => updateData(k, e.target.value)}
        disabled={isDisabled}
        style={{ maxWidth: '100%' }}
      />
    </div>
  );
};

export default Text;
